import request from '../utils/request'

export default {
  // 获取所有
  findAll(params) {
    return request.get('/api/target', { params })
  },

  // 获取已经分配的设备
  findByActivityId(params) {
    return request.get('/api/target/findByActivityId/', { params })
  },

  // 获取可分配的设备
  findForAssignTarget(params) {
    return request.get('/api/target/findForAssignTarget', { params })
  },
  
  // 根据ID获取
  findById(id) {
    return request.get(`/api/target/${id}`)
  },
  
  // 添加精度靶
  add(target) {
    return request.post('/api/target', target)
  },
  
  // 更新精度靶
  update(id, target) {
    return request.put(`/api/target/${id}`, target)
  },
  
  // 删除精度靶
  delete(id) {
    return request.delete(`/api/target/${id}`)
  },
  
  // 批量删除精度靶
  deleteBatch(ids) {
    return request.delete('/api/target/batch', { data: ids })
  },

  // 检查权限编码是否存在
  checkUniqueCode(params) {
    return request.get('/api/target/checkUniqueCode', { params })
  },

  downloadTemplate(params) {
    return request({
      url: '/api/target/downloadTemplate',
      method: 'get',
      params, // 传递前端组装的参数
      responseType: 'blob' // 明确指定响应为二进制流（Excel文件）
    })
  },

  importTargets(formData) {
    return request({
      url: '/api/target/importTargets',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data' // 上传文件需指定该类型
      }
    });
  },

  exportTargets(params) {
    return request({
      url: '/api/target/exportTargets',
      method: 'get',
      params,
      responseType: 'blob' // 导出文件需指定响应类型为blob
    });
  },

  // 批量生成二维码
  batchGenerate(imeiList) {
    return request({
      url: '/api/target/qrcode/batchGenerate',
      method: 'post',
      data: imeiList,
      responseType: 'blob' // 导出文件需指定响应类型为blob
    });
  },
}